import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import RangeSliderBorderRadius from "../../../UI/RangeSliderBorderRadius";
import { Minus, Plus } from "lucide-react";
const ItemWordSpacingUI =  ({ itemsArray, callbackItemValue, objectValue,objectName,displayName ,}) => {
  const [items ,setItems] =useState(itemsArray);
const [resolution, setPxPercent] = useState('px');
     const dispatch = useDispatch();  
     const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
            {
              
              dispatch({type: "CURSOR",payload:true  });
          
              dispatch({type: "CURSORTEXT",payload:CursorText})
              dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
              dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
            }
             
            const handleMouseLeave = () => {
              
              dispatch({type: "CURSOR",payload:false})
          
              dispatch({type: "CURSORTEXT",payload:""})
          
              dispatch({type: "CURSORTEXTBG",payload:""})
              dispatch({type: "CURSORTEXTCOLOR",payload:""})
            
          
          }
 const [itemValue, setItemValue] = useState(objectValue);
const [itemType, setItemType] = useState("num");
 return(<>


<div style={{background:"#ffffff",borderRadius:"15px",marginTop:"0px",padding:"10px",}}>
       
               
             <div className="" style={{background:"rgba(144, 202, 249,0.2)",borderRadius:"10px",marginTop:"0px",marginBottom:"0px",paddingTop:"5px",paddingBottom:"5px",paddingBottom:"5px"}}> 
        
                      
            <h4 style={{display:"flex",justifyContent:"space-between",position:"relative"}}>{displayName} </h4>
            {itemType=="num"?
             <div style={{display:"flex",justifyContent:"space-between",position:"relative"}}>
                                                   
                                                      <div style={{margin: '5px' ,paddingLeft:"0px",width:"110px", display:"grid", gridTemplateColumns: "50% 30% 0%" ,alignItems:"center"  }}>
 <Minus  onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  onClick={()=>{
callbackItemValue({title:objectValue?.title,value:parseInt(objectValue?.value)>1?parseInt(objectValue?.value)-2:10,resolution:"px"},`${objectName}`);
     }} style={{border:"3px solid rgba(144, 202, 249,1) ",width:"25px",height:"25px",borderRadius:"50%",marginLeft:"0px",
        alignContent:"center",textAlign:"center",padding:"5px",cursor:"pointer"}} color="rgba(144, 202, 249,1)" size={13}/>
    <input onMouseEnter={handleMouseEnter} disabled
     onMouseLeave={handleMouseLeave}  value={parseInt(objectValue?.value)} type="number"
          onChange={(e)=>{
          callbackItemValue({title:objectValue?.title,value:parseInt(e.target.value),resolution:"px"},`${objectName}`);
          }}
          style={{border:"0px dashed #555555  ",borderRadius:"10px",outline:0,width:"50px",
            padding:"0px",marginLeft:"5px",fontSize:"20px",color:"#555555 ",fontWeight:"bolder",marginTop:"0px",}}
      />  <Plus onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}  onClick={()=>{
     
           
   callbackItemValue({title:objectValue?.title,value:parseInt(objectValue?.value)<100?parseInt(objectValue?.value)+2:10,resolution:"px"},`${objectName}`);
      
      }}  style={{border:"3px solid rgba(144, 202, 249,1) ",width:"25px",height:"25px",borderRadius:"50%",marginRight:"0px",
        alignContent:"center",textAlign:"center",padding:"5px",cursor:"pointer"}}  color="rgba(144, 202, 249,1)" size={13}/>
        
        
        
        </div>
        
         <div class="input-card-outer"style={{
                 
                  transition: 'transform 3s ease, opacity 3s ease',
                borderRadius:"25px",padding:"0px"}} >
                                          
                                          <div  style={{display:"flex",justifyContent:"space-around"}}>
                                                  <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                             <div style={{display:"flex",justifyContent:"space-between"}} >
                                              
                                            Number
                                                                      </div>  
                              <input type="radio" title="Set As Years"   checked={itemType=="num"?"yes":""}
                   className="input-textbox"  value={"num"}  name={objectName}  
                   onClick={e=>{setItemType("num");
                  }}/>
                        <span class={"boxCardBorder-two"}></span> </label> <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                             <div style={{display:"flex",justifyContent:"space-between"}} >
                                              
                                             Slider
                                                                      </div>  
                              <input type="radio" title="Set As Years"   checked={itemType=="rangeSlider"?"yes":""}
                   className="input-textbox"  value={"rangeSlider"}  name={objectName}  
                   onClick={e=>{setItemType("rangeSlider");
                  }}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                        
                        
                        </div>
                        </div>
           
                       </div> :""}
                        <div style={{display:"flex",justifyContent:"space-around"}}>
                        <div style={{}}>

                            
            {itemType=="rangeSlider"?<div style={{display:"flex",justifyContent:"space-between",}}><RangeSliderBorderRadius resolution={resolution}  setSliderVal={(val)=>{ 
              
              callbackItemValue({title:objectValue?.title,value:val,resolution:resolution},`${objectName}`)}}  
               sliderVal={objectValue?.value} /><div class="input-card-outer"style={{
                 
                  transition: 'transform 3s ease, opacity 3s ease',
                borderRadius:"25px",padding:"0px"}} >
                                          
                                          <div  style={{display:"flex",justifyContent:"space-around"}}>
                                                  <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                             <div style={{display:"flex",justifyContent:"space-between"}} >
                                              
                                            Number
                                                                      </div>  
                              <input type="radio" title="Set As Years"   checked={itemType=="num"?"yes":""}
                   className="input-textbox"  value={"num"}  name={objectName}  
                   onClick={e=>{setItemType("num");
                  }}/>
                        <span class={"boxCardBorder-two"}></span> </label> <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                             <div style={{display:"flex",justifyContent:"space-between"}} >
                                              
                                             Slider
                                                                      </div>  
                              <input type="radio" title="Set As Years"   checked={itemType=="rangeSlider"?"yes":""}
                   className="input-textbox"  value={"rangeSlider"}  name={objectName}  
                   onClick={e=>{setItemType("rangeSlider");
                  }}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                        
                        
                        </div>
                        </div></div>:""}
             
              </div>
              
                        
                

                                                    </div></div>
                            </div>     </>)

    } 
    export default ItemWordSpacingUI;

                     

